export class NICEDialerListMgmtSettings {
    displayField1Name: string;
    displayField2Name: string;
    listOrderingOptions: ListOrderingOptions[];

    // Map for displayField1Id to names
    private static displayFieldMap: Map<number, string> = new Map([
        [-4, "Address"],
        [-13, "CallerID"],
        [-5, "City"],
        [-15, "ComplianceRequired"],
        [-10, "CustomerField1"],
        [-11, "CustomerField2"],
        [-9, "ExternalID"],
        [-14, "PreviewRequired"],
        [-8, "Priority"],
        [-12, "Score"],
        [-6, "State"],
        [-17, "TimeZone"],
        [-7, "Zip"]
    ]);


    constructor(jsonObject?) {
        this.displayField1Name = jsonObject?.displayField1Name ?? (NICEDialerListMgmtSettings.displayFieldMap.get(jsonObject?.displayField1Id) || null);
        this.displayField2Name = jsonObject?.displayField2Name ?? (NICEDialerListMgmtSettings.displayFieldMap.get(jsonObject?.displayField2Id) || null);
        this.listOrderingOptions = jsonObject?.listOrderingOptions;
    }
}

export class ListOrderingOptions {
    orderType: string;
    direction: string;

    constructor(jsonObject)
    {
        if (jsonObject) {
            this.orderType = jsonObject.orderType ;
            this.direction = jsonObject.direction.upperCase() ;
        }
    }
}
